import { RETRYABLE } from '@gk/contracts'
import type { GkDb, OutboxRow } from './db.ts'
import { isTransient } from './transient.ts'

/** The sync page's three lists, each read by its own statuses over the WHOLE outbox, newest first. A refusal of the morning must still show at the end
 *  of the day however many commands came after it, and agree with the header badge, which counts every row by status (never a window of the last N). */
export const REFUSED_STATUSES = ['rejected', 'conflict', 'error'] as const
const RECENT: ReadonlySet<string> = new Set(['applied', 'applied_with_exception', 'discarded'])

/** Not yet answered: queued, waiting for a retry, or being sent. */
export const waitingRows = (db: GkDb): Promise<OutboxRow[]> =>
  db.outbox.where('status').anyOf([...RETRYABLE, 'sending']).reverse().sortBy('local_seq')

/** Refused by the server: the person must see each one (and may dismiss it). */
export const attentionRows = (db: GkDb): Promise<OutboxRow[]> =>
  db.outbox.where('status').anyOf([...REFUSED_STATUSES]).reverse().sortBy('local_seq')

/** The last answered actions of the person. Transient commands (a shared position, every few minutes while a timer runs) are left out: the phone sends
 *  them in the background, and they leave the device once answered (sync/transient.ts). */
export const recentRows = (db: GkDb, n = 10): Promise<OutboxRow[]> =>
  db.outbox.orderBy('local_seq').reverse().filter((r) => RECENT.has(r.status) && !isTransient(r.name, r.payload)).limit(n).toArray()
